import { ReactSVG } from 'react-svg';
import Button from '../Button/ButtonComponent';
import ModalComponent from '../Modal';
import { useState } from 'react';
import styles from './Delete.module.scss';
import { useRouter } from 'next/router';
import { dataResources } from '@portal-internet/core';
import { useRedlMetadata } from 'hooks/useRedlMetadata';

const { basePath } = dataResources;

export default function DeleteComponent({ blocIdx }) {
    const router = useRouter();
    const { deleteRedlBloc } = useRedlMetadata(router.pathname);
    const [show, setShow] = useState(false);
    const onDelete = () => {
        setShow(true);
    };
    const hideModal = () => {
        setShow(false);
    };

    const onDeleteConfirm = () => {
        deleteRedlBloc(blocIdx);
        hideModal();
    };

    return (
        <>
            <Button variant="edit" size="sm" onClick={onDelete} data-testid={`REDL-delete-button-${blocIdx}`}>
                <ReactSVG src={basePath + '/_resources/REDL/icons/trash.svg?v=JIT_ENV_RESOURCES_VERSION'} />
            </Button>
            <ModalComponent show={show} hideModal={hideModal}>
                <div className={styles.deleteWrapper} data-testid={`REDL-delete-component-${blocIdx}`}>
                    <p className={styles.deleteText}>Voleu eliminar aquest bloc?</p>
                    <div className={styles.deleteButtonsWrapper}>
                        <Button variant="tertiary" size="sm-lg" onClick={hideModal}
                                data-testid={`REDL-delete-cancel-button-${blocIdx}`}>Cancel·la</Button>
                        <Button variant="primary" size="sm-lg" onClick={onDeleteConfirm}
                                data-testid={`REDL-delete-confirm-button-${blocIdx}`}>Confirmar</Button>
                    </div>
                </div>
            </ModalComponent>
        </>
    );
}